import { useMemo } from "react";
import { generateFieldName } from "@/components/site-builder/modules/CustomFormModule/utils/generateFieldName";
import type { FormBuilderFormField } from "@/types/form-builder";

export function useCustomFormFieldProps(field: FormBuilderFormField) {
  return useMemo(() => {
    const { label, placeholderText, showLabel, showPlaceHolder, required } =
      field;
    const fieldLabel = showLabel ? label : undefined;
    const fieldPlaceholder = showPlaceHolder ? placeholderText : undefined;
    const fieldName = generateFieldName(field);
    const fieldRules = required ? { required } : undefined;

    return {
      fieldLabel,
      fieldPlaceholder,
      fieldName,
      fieldRules,
    };
  }, [field]);
}
